module.exports = __webpack_public_path__ + "img/education.0b38cb30.png";